/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import QueueIcon from "@mui/icons-material/Queue";
import { PlanId } from "components/common/boundary/PlanId";
import { useTenantTranslation } from "hooks/formatters";
import { resolvedBackupStatuses, useBackups } from "hooks/useBackups";
import {
  PreFetchButton,
  PreFetchButtonConfig,
} from "../topButtons/preFetchButton";
import { BackupModal } from "./backupModal";
import { mapLoadedUnpack } from "models/loaded";
import { useSearch } from "contexts/search/SearchContextProvider";

interface Props {
  planId: PlanId;
}

interface BackupModalWrapperProps {
  open: boolean;
  handleClose: () => void;
  planId: PlanId;
}

const BackupModalWrapper = ({
  open,
  handleClose,
  planId,
}: BackupModalWrapperProps) => {
  const backups = useBackups(planId);

  if (!backups.isSuccess) return null;

  return (
    <BackupModal
      open={open}
      close={handleClose}
      backups={backups.data.backups}
    />
  );
};

export const BackupButton = ({ planId }: Props) => {
  const { t } = useTenantTranslation();
  const backups = useBackups(planId);

  const hasValidBackups =
    backups.isSuccess &&
    backups.data.backups.length > 0 &&
    backups.data.backups.every((backup) =>
      resolvedBackupStatuses.includes(backup.status)
    );

  const searchType = mapLoadedUnpack(
    useSearch().parameters.server,
    ({ search_type }) => search_type
  );

  const config: PreFetchButtonConfig = {
    label: t("backups"),
    icon: <QueueIcon />,
    disabled:
      !hasValidBackups || searchType === null || searchType === undefined,
    isLoading: backups.isLoading,
    isSuccess: backups.isSuccess,
    modalComponent: BackupModalWrapper,
    searchType,
  };

  return <PreFetchButton planId={planId} config={config} />;
};
